import React from 'react'
import { parseHtmlToReact, parseJson, prepareForParse } from '../../utils'
import { useStaticQuery, graphql } from 'gatsby'
// Swiper
import { Autoplay, Pagination, Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/autoplay'
import 'swiper/css/pagination'
import 'swiper/css/navigation'

export const CustomSwiperInformation = ({
  data: { pageContext, ...pageData },
  // component props
  label = '',
  limit = undefined,
  templateName = 'customSwiperInformation',
  defaultImagePrefix = '',
  children,
  ...swiperProps
}) => {
  const { locale } = pageContext

  // Swiper
  const coreModules = []
  if ('autoplay' in swiperProps) {
    coreModules.push(Autoplay)
  }
  if ('pagination' in swiperProps) {
    coreModules.push(Pagination)
  }
  if ('navigation' in swiperProps) {
    coreModules.push(Navigation)
  }

  // Template 取得
  // 本来であれば variables で絞り込みたいが、制約がありできない
  // https://www.gatsbyjs.com/docs/how-to/querying-data/use-static-query/#known-limitations
  const data = useStaticQuery(graphql`
    {
      allContentfulTemplate(
        filter: { name: { regex: "/^customSwiperInformation.*$/" } }
      ) {
        nodes {
          contentful_id
          __typename
          node_locale
          name
          body {
            raw
          }
          context {
            internal {
              content
            }
          }
        }
      }
      allContentfulImage(
        sort: { name: ASC }
        filter: { name: { regex: "/^customSwiperInformation-default-.*$/" } }
      ) {
        nodes {
          contentful_id
          __typename
          node_locale
          name
          props {
            internal {
              content
            }
          }
          body {
            gatsbyImageData
          }
        }
      }
    }
  `)
  const template = data.allContentfulTemplate.nodes.find(
    (node) => node.node_locale === locale && node.name === templateName
  )
  if (template === undefined) {
    throw new Error(
      `Template not found. templateName: ${templateName}, locale: ${locale}`
    )
  }

  const { categoryList = {} } =
    parseJson(template.context?.internal?.content) ?? {}

  // component props の label には複数ラベルを設定可能
  const filterLabels = label.split(',').filter((item) => item !== '')

  const contents = pageData.allContentfulInformation.nodes
    .filter((node) => node.node_locale === locale)
    .filter(
      (node) => filterLabels.length === 0 || filterLabels.includes(node.label)
    )
    .slice(0, limit)

  // デフォルト画像を取得、設定する
  const defaultImages = data.allContentfulImage.nodes.filter((node) => {
    const name = `customSwiperInformation-default-${defaultImagePrefix}`
    return node.node_locale === locale && node.name.indexOf(name) === 0
  })

  return (
    <Swiper modules={coreModules} {...swiperProps}>
      {contents.map((node, index) => {
        const { htmlBody, componentData } = prepareForParse({
          template,
          data: {
            ...pageData,
            contentfulInformation: node,
            context: {
              categoryName: categoryList?.[node.label],
              ...(node.thumbnail ? {} : { thumbnail: defaultImages?.[index] }),
            },
          },
          pageContext,
        })

        return (
          <SwiperSlide key={index}>
            {parseHtmlToReact(htmlBody, componentData)}
          </SwiperSlide>
        )
      })}
      {children}
    </Swiper>
  )
}
